import { IUploadProps } from '../FormUploadFile.interfaces';
import { useDropzone } from 'react-dropzone';
import { Box } from '../../../base-components';
import { StyledDropZone } from './UploadFile.styles';
import Placeholder from './Placeholder';
import { useTheme } from '@mui/material/styles';
import SingleFilePreview from '../Previews/FilePreview';
import ErrorFiles from '../Previews/ErrorFile';

const UploadFile = (props: IUploadProps) => {
    const {
        disabled,
        multiple = false,
        error,
        helperText,
        //
        file,
        onDelete,
        //
        files,
        thumbnail,
        onUpload,
        onRemove,
        onRemoveAll,
        sx,
        ...other
    } = props;
    const {
        getRootProps,
        getInputProps,
        isDragActive,
        isDragReject,
        fileRejections,
    } = useDropzone({
        multiple,
        disabled,
        ...other,
    });
    const hasFile = !!file && !multiple;
    const hasFiles = files && multiple && files.length > 0;
    const isError = isDragReject || !!error;
    const theme = useTheme();

    return (
        <Box sx={{ width: 1, position: 'relative', ...sx }}>
            <StyledDropZone
                {...getRootProps()}
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    bgcolor: theme.palette.primary.light,
                    border: `1px dashed ${theme.palette.primary.main}`,
                    padding: theme.spacing(1.5),
                    ...(isDragActive && {
                        opacity: 0.72,
                    }),
                    ...(isError && {
                        color: 'error.main',
                        bgcolor: 'error.light',
                        borderColor: 'error.light',
                    }),
                    ...(disabled && {
                        opacity: 0.48,
                        pointerEvents: 'none',
                    }),
                    ...sx,
                }}
            >
                <input {...getInputProps()} />

                <Placeholder />
            </StyledDropZone>

            {hasFile && <SingleFilePreview file={file} onDelete={onDelete} />}
            {helperText && helperText}

            <ErrorFiles fileRejections={fileRejections} />

            {/* {hasFile && onDelete && (
                <IconButton
                    size="small"
                    onClick={onDelete}
                    sx={{
                        top: 16,
                        right: 16,
                        zIndex: 9,
                        position: 'absolute',
                        color: (theme) =>
                            alpha(theme.palette.common.white, 0.8),
                        backgroundColor: (theme) =>
                            alpha(theme.palette.grey[900], 0.72),
                        '&:hover': {
                            backgroundColor: (theme) =>
                                alpha(theme.palette.grey[900], 0.48),
                        },
                    }}
                >
                    <CloseIcon />
                </IconButton>
            )} */}

            {/* {hasFiles && (
                <>
                    <Box sx={{ my: 3 }}>
                        <MultiFilePreview
                            files={files}
                            thumbnail={thumbnail}
                            onRemove={onRemove}
                        />
                    </Box>

                    <Stack
                        direction="row"
                        justifyContent="flex-end"
                        spacing={1.5}
                    >
                        {onRemoveAll && (
                            <Button
                                color="inherit"
                                variant="outlined"
                                size="small"
                                onClick={onRemoveAll}
                            >
                                {t('uploadFile.removeAll')}
                            </Button>
                        )}

                        {onUpload && (
                            <Button
                                size="small"
                                variant="contained"
                                onClick={onUpload}
                            >
                                {t('uploadFile.uploadFiles')}
                            </Button>
                        )}
                    </Stack>
                </>
            )} */}
        </Box>
    );
};

export default UploadFile;
